<script>

export default
{
    name: 'privacy-policy',

    render () 
    {
        return (
            <div id='privacy-policy-view'>
                <div class='title'>Politique de confidentialité</div>
                <div class='agreement'>
                    <p> Ma Ville, accessible depuis <b>https://www.app-maville.com</b> ou joignable à <b>contact@app-maville.com</b>, donne la priorité à la confidentialité de ses visiteurs. Ce document de politique de confidentialité contient les types d'informations collectées et enregistrées par Ma Ville et la manière dont nous les utilisons. </p>

                    <p> Si vous avez des questions supplémentaires ou avez besoin de plus d'informations sur notre politique de confidentialité, n'hésitez pas à nous contacter. </p>

                    <h2> Consentement </h2>

                    <p> En utilisant notre site Web et / ou une ou plusieurs de nos applications, vous acceptez par la présente notre politique de confidentialité et ses conditions. </p>

                    <h2> Informations que nous collectons </h2>

                    <p> Les informations personnelles que vous êtes invité à fournir et les raisons pour lesquelles vous êtes invité à les fournir vous seront précisées au moment où nous vous demanderons de fournir ces informations personnelles. </p>
                    <p> Si vous nous contactez directement, nous pouvons recevoir des informations supplémentaires vous concernant, telles que votre nom, votre courriel, votre numéro de téléphone, le contenu du message et / ou des pièces jointes que vous pouvez nous envoyer, ainsi que toute autre information que vous pourriez choisir de fournir. </p>
                    <p> Lorsque vous vous inscrivez à un compte, nous pouvons vous demander vos coordonnées, y compris des éléments tels que le nom, le nom de commune, son département, l'adresse, l'adresse e-mail et le numéro de téléphone. </p>
                    <p> Lors de l'utilisation du service de signalement vous pouvez être mené à fournir votre géolocalisation, qui reste strictement confidentielle et n'est partagée qu'avec la mairie destinataire. </p>

                    <h2> Comment nous utilisons vos informations </h2>

                    <p> Nous utilisons les informations que nous collectons de diverses manières, notamment pour: </p>

                    <ul>
                        <li> Fournir, exploiter et maintenir notre site Web </li>
                        <li> Améliorer, personnaliser et élargir notre site Web </li>
                        <li> Comprendre et analyser la façon dont vous utilisez notre site Web </li>
                        <li> Développer de nouveaux produits, services, caractéristiques et fonctionnalités </li>
                        <li> Communiquez avec vous, directement ou par l'intermédiaire de l'un de nos partenaires, y compris pour le service client, pour vous fournir des mises à jour et d'autres informations relatives au site web et applications, ainsi qu'à des fins de marketing et de promotion </li>
                        <li> Vous envoyer des e-mails </li>
                        <li> Trouver et prévenir les fraudes </li>
                    </ul>

                    <h2> Fichiers journaux </h2>

                    <p> Ma Ville suit une procédure standard d'utilisation des fichiers journaux. Ces fichiers enregistrent les visiteurs lorsqu'ils visitent des sites Web. Toutes les sociétés d'hébergement font cela et cette pratique fait partie de l'analyse des services d'hébergement. Les informations collectées par les fichiers journaux incluent les adresses de protocole Internet (IP), le type de navigateur, le fournisseur d'accès Internet (FAI), la date et l'heure, les pages de renvoi / sortie et éventuellement le nombre de clics. Ceux-ci ne sont liés à aucune information personnellement identifiable. Le but des informations est d'analyser les tendances, d'administrer le site, de suivre les mouvements des utilisateurs sur le site Web et de collecter des informations démographiques. </p>

                    <h2> Politiques de confidentialité des tiers </h2>

                    <p> La politique de confidentialité de Ma Ville ne s'applique pas aux autres annonceurs ou sites Web. Ainsi, nous vous conseillons de consulter leurs politiques de confidentialité respectives. </p>

                    <h2> Droits de protection des données GDPR </h2>

                    <p> Nous souhaitons nous assurer que vous connaissez parfaitement tous vos droits en matière de protection des données. Chaque utilisateur a droit à ce qui suit: </p>
                    <ul>
                        <li> Le droit d'accès - Vous avez le droit de demander des copies de vos données personnelles. Nous pouvons vous facturer une somme modique pour ce service. </li>
                        <li> Le droit de rectification - Vous avez le droit de demander que nous corrigions toute information que vous jugez inexacte. Vous avez également le droit de demander que nous complétions les informations que vous jugez incomplètes. </li>
                        <li> Le droit à l'effacement - Vous avez le droit de demander que nous effacions vos données personnelles, sous certaines conditions. </li>
                        <li> Le droit de restreindre le traitement - Vous avez le droit de demander que nous restreignions le traitement de vos données personnelles, sous certaines conditions. </li>
                        <li> Le droit de vous opposer au traitement - Vous avez le droit de vous opposer au traitement de vos données personnelles, sous certaines conditions. </li>
                        <li> Le droit à la portabilité des données - Vous avez le droit de demander que nous transférions les données que nous avons collectées à une autre organisation, ou directement à vous-même, sous certaines conditions. </li>
                    </ul>
                    <p> Si vous faites une demande, nous avons un mois pour vous répondre. Si vous souhaitez exercer l'un de ces droits, veuillez nous contacter. </p>

                    <h2> Informations pour les enfants </h2>

                    <p> Une autre partie de notre priorité consiste à ajouter une protection pour les enfants lors de l'utilisation d'Internet. Nous encourageons les parents et les tuteurs à observer, participer et / ou surveiller et guider leur activité en ligne. </p>

                    <p> Ma Ville ne collecte sciemment aucune information personnelle identifiable d'enfants de moins de 13 ans. Si vous pensez que votre enfant a fourni ce type d'informations sur notre site Web, nous vous encourageons fortement à nous contacter immédiatement et nous ferons de notre mieux pour supprimer rapidement ces informations de nos dossiers. </p>
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#privacy-policy-view
{
    width: 100%;
    padding-top: 15vh;

    & .title
    {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        font-size: 6vw;

        .OnTablet({ font-size: 4.5vw; });
        .OnDesktop({ font-size: 2vw; });
    }

    & .agreement
    {
        margin-top: 10vh;
        margin-bottom: 10vh;
        width: 90%;
        margin-left: 5%;

        .OnTablet({
            width: 70%;
            margin-left: 15%;
        });

        .OnDesktop({
            width: 60%;
            margin-left: 20%;
        });

        h2
        {
            margin: 2vh 0;
        }

        b
        {
            color: var(--theme-accent-color);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/PrivacyPolicy.vue